import projectList1 from './list1.vue'
import projectList2 from './list2.vue'
import projectList3 from './list3.vue'
import activevitylist from './activitylist'
import Costing from './Costing'
import addCosting from './addCosting'
import contractList from "./contractList.vue"
import contractEditAll from './contractEditAll.vue'
import invoiceList from "./invoiceList.vue"
import ProcessList from "./ProjectProcess.vue" //项目流程
import projectAllList from './allList.vue'
import Statistics from './statistics.vue'//统计分析

let a = Object.assign({ Statistics, projectAllList, projectList1, projectList2, projectList3, contractList, contractEditAll, invoiceList, ProcessList }, activevitylist,Costing,addCosting)
export default a
